import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PreviewModeContext = createContext(false);

export function PreviewModeProvider({ children }) {
    const location = useLocation();

    // Check URL param
    const urlHasPreview = new URLSearchParams(location.search).get('preview') === 'admin';

    const [isPreview, setIsPreview] = useState(() => {
        // On first load: check URL first, then sessionStorage
        if (new URLSearchParams(window.location.search).get('preview') === 'admin') return true;
        return sessionStorage.getItem('adminPreviewMode') === 'true';
    });

    useEffect(() => {
        if (urlHasPreview) {
            // Persist in sessionStorage so it survives React Router navigations
            sessionStorage.setItem('adminPreviewMode', 'true');
            setIsPreview(true);
        }
    }, [urlHasPreview]);

    return (
        <PreviewModeContext.Provider value={isPreview}>
            {children}
        </PreviewModeContext.Provider>
    );
}

export function usePreviewMode() {
    return useContext(PreviewModeContext);
}